import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";

@Injectable({
  providedIn: "root"
})
export class LangService {
  constructor(private apiService: ApiService) {}

  getLanguageList(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const parameters = {};
      this.apiService.get({ url: apiColletions.language, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
